import { MessageType } from 'magpie-types';
import { createError } from './create-error';

export const MessageDispatchError = createError(
  'MessageDispatchError',
  (messageType: MessageType) =>
    `Failed to dispatch message of type ${messageType}.`,
  {
    HANDSHAKE_FAILED: 'Connection unavailable. Handshake not finalized.',
    CONNECTION_UNAVAILABLE: "Connection wasn't opened",
  } as const
);
